import type { FieldProps } from 'formik'
import { Icon, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import { Form } from 'react-bootstrap'
import type { ReactNode } from 'react'
import React from 'react'

type HelpBlockLayoutProps = { showError: boolean; formikField?: FieldProps; help?: string | ReactNode; meta?: any }
export const HelpBlockLayout = ({ meta, formikField, help, showError }: HelpBlockLayoutProps) => {
  meta = meta || formikField?.meta
  return (
    <>
      <ShowIf condition={help && !showError}>
        <Form.Text muted>{help}</Form.Text>
      </ShowIf>

      <ErrorBlockLayout showError={showError} meta={meta} formikField={formikField} />
    </>
  )
}

export const ErrorBlockLayout = ({ meta, formikField, showError }: HelpBlockLayoutProps) => {
  meta = meta || formikField?.meta

  return (
    <ShowIf condition={showError}>
      {/* text-danger is `--bs-danger-rgb` — a fixed hex, never re-tinted for [data-bs-theme=dark]
          (webui-styling-style-guide.md §3), so it fails the 4.5:1 text floor at ~3.4:1 in dark.
          text-danger-emphasis reads `--bs-danger-text-emphasis`, which IS re-tinted per theme:
          rgb(88, 21.2, 27.6) on light body-bg #fff, rgb(234, 133.8, 143.4) on dark body-bg
          #212529 — ~6.1:1, clearing SC 1.4.3. */}
      <Form.Text className="text-danger-emphasis">{meta?.error}</Form.Text>
    </ShowIf>
  )
}

type HelpTooltipProps = { help: string | ReactNode }
export const HelpTooltip = ({ help }: HelpTooltipProps) => {
  //exit if there is no help
  if (!help) return null

  return (
    <TooltipPopOver tooltipBody={help}>
      <Icon name="circle-question" />
    </TooltipPopOver>
  )
}
